import { Wrap } from './styles';

import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import MetadataView from 'components/MetadataView';
import { useEffect, useState } from 'react';

/**
 * Component para exibição dos metadados dentro do PopOver
 */
export const Metadata = ({
  layer,
  handleClosePopOver,
  canShowLinkService,
  hasMetadata
  }) => {    
    const [layerMetadata, setLayerMetadata] = useState(null);
    const [metadataPageLink, setMetadataPageLink] = useState(null);

    // Configurações básicas da camada
    useEffect(() => {
      // Obtenção dos metadados
      if (layer.getMetadataXmlLink()) {
        setMetadataPageLink(layer.getMetadataPageLink());      
        layer
          .loadMetadata()
          .then((metadata) => setLayerMetadata(metadata))
      } 
      
    }, [layer]);

    return(
      <Wrap maxWidth="350px">
        <div className="header">
            <h3>Metadados</h3>
            <IconButton
            size="small"
            onClick={handleClosePopOver}
            className="btn-close"
            >
            <CloseIcon />
            </IconButton>
        </div>
        <hr />
        <div className="content">
            <MetadataView
            hasMetadata={hasMetadata}
            layerMetadata={layerMetadata}
            metadataLink={metadataPageLink}
            onlyContent
            serviceLink={layer.getFullServiceLink(layer.getService())}
            canShowLinkService={canShowLinkService && layer.type === 'externa'}
            descriptionOverflow="160px"
            />
        </div>
      </Wrap>
    )
}